import React from 'react'
import PropTypes from 'prop-types'
import { get, isPresent } from 'lodash'
import Icon from 'UI/FontAwesomeIcon'

const fontSizes = {
  big: '20px',
  normal: '15px',
  small: '10px',
}

const greyIcon = { color: 'grey', icon: 'alicorn', type: 'fad', title: 'RAG not found' }

const RAGIcon = ({ color, onClick, icon, redIcon, amberIcon, greenIcon, pinkIcon, styles, size, title }) => {
  const ragIcon = get({
    red: redIcon,
    amber: amberIcon, orange: amberIcon,
    green: greenIcon,
    deeppink: pinkIcon,
    grey: greyIcon, gray: greyIcon,
  }, color, greyIcon)

  if(isPresent(icon)) {
    ragIcon.icon = icon
  }

  return (
    <span style={{ color: ragIcon.color, fontSize: fontSizes[size], ...styles }} onClick={onClick}>
      <Icon { ...{ ...ragIcon, title } } /> {ragIcon.text}
    </span>
  )
}

RAGIcon.propTypes = {
  onClick: PropTypes.func,
  redIcon: PropTypes.shape({ icon: PropTypes.string, type: PropTypes.string, text: PropTypes.string }),
  amberIcon: PropTypes.shape({ icon: PropTypes.string, type: PropTypes.string, text: PropTypes.string }),
  greenIcon: PropTypes.shape({ icon: PropTypes.string, type: PropTypes.string, text: PropTypes.string }),
  pinkIcon: PropTypes.shape({ icon: PropTypes.string, type: PropTypes.string, text: PropTypes.string }),
  styles: PropTypes.shape(PropTypes.any)
}

RAGIcon.defaultProps = {
  onClick: () => undefined,
  redIcon:   { color: 'red', icon: 'times', type: 'solid', text: '' },
  amberIcon: { color: '#FF9900', icon: 'exclamation-triangle', type: 'solid', text: '' },
  greenIcon: { color: 'green', icon: 'check', type: 'solid', text: '' },
  pinkIcon: { color: 'deeppink', icon: 'horse', type: 'solid', text: '' },
  styles: { display: 'flex', justifyContent: 'center' },
  title: null,
  size: 'normal'
}

export default RAGIcon
